const SvgPending = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.12963 1.63647L1.09094 10.3637H11.1683L6.12963 1.63647Z"
        fill="#F5C502"
      />
    </svg>
  );
};

export default SvgPending;
